export const getDefaultValues = (profileRewardDetails) => ({
  ProfileApplicationRewardAmount: profileRewardDetails?.ProfileApplicationRewardAmount || '',
});
